import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { useFutureOrderStore } from '../../../../../components/Stores/FutureOrdersStore';
import ButtonDesigned from '../../../../../components/UI-Elements/Buttons/ButtonDesigned';

interface Props {
  backAction: () => void;
  nextAction: () => void;
  isButtonLoading?: boolean;
}

export const FOIndexedRawMaterialsButtonSection: React.FC<Props> = ({
  backAction,
  isButtonLoading = false,
  nextAction,
}) => {
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const { editedFutureOrder } = useFutureOrderStore();

  useEffect(() => {
    if (editedFutureOrder.supplierExposure.length > 0) {
      setIsNextDisabled(false);
    } else {
      setIsNextDisabled(true);
    }
  }, [editedFutureOrder]);

  return (
    <div className="flex gap-4">
      <ButtonDesigned
        disableButton={isButtonLoading}
        isFunctionLoading={isButtonLoading}
        style="outline"
        onButtonClick={backAction}
      >
        <ChevronLeft />
        Back
      </ButtonDesigned>
      <ButtonDesigned
        isFunctionLoading={isButtonLoading}
        disableButton={isNextDisabled || isButtonLoading}
        style="primary"
        onButtonClick={nextAction}
      >
        Next <ChevronRight />
      </ButtonDesigned>
    </div>
  );
};
